import { useState } from "react";
import { Link } from "react-router-dom";
import api, { apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Crown, Mail, CheckCircle2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
    } catch (err) {
      toast.error(apiErr(err.response?.data?.detail) || "Erro ao solicitar");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#09090b] flex items-center justify-center px-4 relative overflow-hidden">
      <div className="absolute inset-0 opacity-20">
        <img src="https://images.unsplash.com/photo-1503951914875-452162b0f3f1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600" alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/90 to-black" />
      </div>
      <div className="relative w-full max-w-md bg-zinc-900/90 backdrop-blur border border-zinc-800 rounded-2xl p-8 animate-fade-up">
        <Link to="/" className="flex flex-col items-center mb-6">
          <Crown className="w-8 h-8 text-amber-400 mb-2" />
          <span className="font-display text-2xl gold-text font-bold">Barbearia Big Black</span>
        </Link>

        {sent ? (
          <div className="text-center" data-testid="forgot-sent">
            <CheckCircle2 className="w-12 h-12 text-green-400 mx-auto mb-4" />
            <h2 className="text-white font-heading text-xl font-bold mb-2">Verifique seu e-mail</h2>
            <p className="text-zinc-400 text-sm">Se existir uma conta com esse e-mail, enviamos um link para redefinir a senha. O link expira em 1 hora.</p>
            <Link to="/login" className="inline-block mt-6 text-amber-400 text-sm hover:underline" data-testid="back-to-login">← Voltar ao login</Link>
          </div>
        ) : (
          <>
            <h2 className="text-white font-heading text-xl font-bold mb-1 text-center">Esqueci minha senha</h2>
            <p className="text-zinc-400 text-sm mb-6 text-center">Informe seu e-mail e enviaremos um link para criar uma nova senha.</p>
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label className="text-zinc-300">E-mail</Label>
                <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="voce@email.com" className="mt-1 bg-zinc-800 border-zinc-700" data-testid="forgot-email" />
              </div>
              <Button type="submit" disabled={loading} className="w-full bg-gradient-to-r from-amber-400 to-yellow-600 text-black font-bold rounded-full h-12 hover:brightness-110" data-testid="forgot-submit">
                <Mail className="w-4 h-4 mr-2" /> {loading ? "Enviando..." : "Enviar link de recuperação"}
              </Button>
            </form>
            <Link to="/login" className="block text-center text-zinc-500 text-sm mt-6 hover:text-amber-400">← Voltar ao login</Link>
          </>
        )}
      </div>
    </div>
  );
}
